import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'
import * as ActiveStorage from "@rails/activestorage";

ActiveStorage.start();

createRoot(document.getElementById("root")!).render(<App />);
